import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "./primitives";
import { DOWNLOAD_URL } from "../../data/content";
import { useLanguage } from "../../context/LanguageContext";

const MAP = {
  Home: "#home",
  Beranda: "#home",
  Mods: DOWNLOAD_URL,
  Mod: DOWNLOAD_URL,
  Aplikasi: DOWNLOAD_URL,
  Categories: "#ecosystem",
  Kategori: "#ecosystem",
  "VIP Pricing": "https://berrymodapk.com/VIP",
  "Harga VIP": "https://berrymodapk.com/VIP",
  About: "#about",
  Tentang: "#about",
  Contact: "https://berrymodapk.com/Contact/",
  Kontak: "https://berrymodapk.com/Contact/",
  Privacy: "https://berrymodapk.com/Policy/",
  Privasi: "https://berrymodapk.com/Policy/",
  Terms: "https://berrymodapk.com/Policy/",
  Ketentuan: "https://berrymodapk.com/Policy/",
};

export default function Footer() {
  const { t, lang, setLang } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const go = (l) => {
    const href = MAP[l];
    if (!href) return;
    if (href.startsWith("http")) {
      window.open(href, "_blank", "noopener,noreferrer");
    } else if (href.startsWith("/")) {
      navigate(`/${lang}${href}`);
    } else {
      const isLanding =
        location.pathname.startsWith(`/${lang}`) ||
        location.pathname === `/${lang}/` ||
        location.pathname === "/";
      if (!isLanding) {
        navigate(`/${lang}/${href}`);
      } else {
        scrollToId(href);
      }
    }
  };

  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 bg-[#050507]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-10 py-10 sm:py-16">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 md:gap-12">
          {/* Brand & Tagline */}
          <div className="space-y-2">
            <div className="flex items-center gap-2.5">
              <svg viewBox="0 0 1080 1080" className="w-7 h-7 sm:w-8 sm:h-8" aria-hidden="true">
                <path transform="matrix(0.52734375, 0, 0, 0.52734375, 0, 0)" d="M270.63 377.35 C317 374.69 329.48 396.32 357.39 429.16 L401.48 481.02 L565.85 673.76 C669.46 582.58 818.06 522.37 954.92 509.41 C1146.82 490.25 1338.31 549.54 1485.82 673.79 C1537.52 611.7 1591.35 549.75 1643.8 488.18 L1692.26 431.31 C1712.07 408.1 1728.09 382.69 1760.16 377.68 C1778.22 374.82 1796.68 379.26 1811.46 390.03 C1825.95 400.75 1835.6 416.77 1838.29 434.59 C1840.62 449.39 1837.98 464.55 1830.79 477.7 C1824.2 489.78 1812.51 502.23 1803.41 512.83 L1771.74 549.95 L1644.32 699.49 L1604.45 746.12 C1598.58 753 1588.49 764.15 1583.57 770.97 L1582.41 772.61 C1657.13 869.77 1697.09 951.05 1724.72 1071.18 C1732.47 1106.26 1736.77 1143.2 1739.18 1179.15 C1740.03 1191.94 1739.9 1210.32 1740.44 1223.71 C1741.2 1224.46 1741.95 1225.22 1742.71 1225.98 C1743.5 1314.86 1743.14 1473.69 1743.16 1555.83 L308.12 1555.81 L308.07 1338.36 C308.07 1305.49 308 1272.44 308.17 1239.56 C308.32 1229.85 310.93 1220.05 311.14 1210.37 C311.83 1179.22 314.12 1148.78 318.46 1117.89 C336.7 991.33 388.77 872.04 469.15 772.6 C450.27 749.03 427.81 723.73 408.06 700.57 L295.16 568.2 L252.54 518.21 C238.04 501.19 219.2 482.83 214.13 460.7 C209.89 442.67 213.12 423.7 223.08 408.09 C234.66 389.94 250.27 381.78 270.63 377.35 Z" fill="#436AE7" />
                <path transform="matrix(0.52734375, 0, 0, 0.52734375, 0, 0)" d="M1263.22 921.45 C1321.98 914.45 1375.28 956.41 1382.27 1015.17 C1389.25 1073.93 1347.27 1127.23 1288.51 1134.2 C1229.77 1141.16 1176.5 1099.2 1169.52 1040.46 C1162.54 981.73 1204.48 928.45 1263.22 921.45 Z" fill="#E5E6FB" />
                <path transform="matrix(0.52734375, 0, 0, 0.52734375, 0, 0)" d="M763.07 921.43 C821.93 914.53 875.21 956.73 881.97 1015.6 C888.73 1074.48 846.4 1127.65 787.51 1134.27 C728.82 1140.86 675.86 1098.71 669.13 1040.04 C662.39 981.36 704.42 928.31 763.07 921.43 Z" fill="#E5E6FB" />
              </svg>
              <span className="font-display font-bold text-base sm:text-lg tracking-tight text-white">BERRY MOD APK</span>
            </div>
            <p className="font-mono-tech text-xs sm:text-sm text-white/40 tracking-wide">{t.footer.tagline}</p>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 xs:grid-cols-3 sm:flex sm:flex-wrap gap-x-6 sm:gap-x-8 gap-y-3 md:justify-end">
            {t.footer.links.map((l) => (
              <button
                key={l}
                onClick={() => go(l)}
                data-testid={`footer-link-${l.toLowerCase()}`}
                className="text-left sm:text-center font-mono-tech text-[11px] sm:text-xs uppercase tracking-[0.18em] text-white/45 hover:text-primary transition-colors duration-300 py-1"
              >
                {l}
              </button>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 sm:mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-8 sm:pb-0">
          <span className="font-mono-tech text-[11px] text-white/35 tracking-wide">
            © 2026 BERRY MOD APK. All rights reserved.
          </span>

          {/* Segmented Glass Language Switcher in Footer */}
          <div
            data-testid="footer-language-toggle"
            role="group"
            aria-label="Language selector"
            className="flex items-center p-0.5 rounded-full border border-white/10 bg-[#07080f]/90 backdrop-blur-xl shadow-lg transition-all hover:border-white/20"
          >
            <button
              onClick={() => setLang("id")}
              className={`flex items-center gap-1 px-3 py-1 rounded-full font-mono-tech text-[11px] font-bold transition-all duration-300 ${
                lang === "id"
                  ? "bg-primary text-white shadow-md shadow-primary/30"
                  : "text-white/40 hover:text-white"
              }`}
              title="Bahasa Indonesia"
            >
              <span>ID</span>
            </button>

            <button
              onClick={() => setLang("en")}
              className={`flex items-center gap-1 px-3 py-1 rounded-full font-mono-tech text-[11px] font-bold transition-all duration-300 ${
                lang === "en"
                  ? "bg-primary text-white shadow-md shadow-primary/30"
                  : "text-white/40 hover:text-white"
              }`}
              title="English"
            >
              <span>EN</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
